import { render } from "./ConfigTemporadas.vue?vue&type=template&id=32559940&scoped=true"
import script from "./ConfigTemporadas.vue?vue&type=script&lang=ts"
export * from "./ConfigTemporadas.vue?vue&type=script&lang=ts"

import "./ConfigTemporadas.vue?vue&type=style&index=0&id=32559940&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32559940"

export default script